module.exports = __webpack_public_path__ + "static/media/empty-list.d2f4b8a5.svg";